import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { ArrowRightIcon } from '@synoptic/ui-kit/icons/react/arrow-right.js';
import {
  nudgeLeftContainer,
  nudgeExploreButton,
  nudgeCard,
  nudgeDescription,
  nudgeImage,
  nudgeImageContainer,
  nudgeTitle,
} from './nudge-card.css.ts';

export const NudgeCard = ({
  title,
  description,
  image,
  buttonText,
  onClick,
}: {
  title: string;
  description: string;
  image: { src: string; alt: string };
  buttonText: string;
  onClick: () => void;
}) => {
  return (
    <div className={nudgeCard}>
      <div className={nudgeLeftContainer}>
        <div>
          <h4 className={nudgeTitle}>{title}</h4>
          <p className={nudgeDescription}>{description}</p>
        </div>
        <Button
          size={'small'}
          className={nudgeExploreButton}
          onClick={onClick}
          endIcon={<ArrowRightIcon />}
        >
          {buttonText}
        </Button>
      </div>
      <div className={nudgeImageContainer}>
        <img src={image.src} alt={image.alt} className={nudgeImage} />
      </div>
    </div>
  );
};
